import WRAP from 'WRAP-JS'
import WrapOption from "../constants/WrapOption";
import "./wrap_extention/Renderer";
import "./wrap_extention/Renderer/GeoJSONExt";
import "./wrap_extention/Renderer/GeoJSONExtPopup";
import "./wrap_extention/Renderer/AirwayLine";
import "./wrap_extention/Renderer/AirwayLabel";
import "./wrap_extention/Renderer/TropicalStormExt";
import "./wrap_extention/Renderer/GridValueExt";
import "./wrap_extention/Renderer/LightningExt";
import "./wrap_extention/Renderer/PointArea";
import "./wrap_extention/Renderer/PointAreaExternal";
import "./wrap_extention/Renderer/PointInfoExt";
import "./wrap_extention/Renderer/LiveCameraExt";
import "./wrap_extention/Renderer/PowerLine";
import "./wrap_extention/Renderer/Airport";
import "./wrap_extention/Renderer/Heliport";
import "./wrap_extention/Renderer/PowerPylon";
import "./wrap_extention/Renderer/TrackLine";
import "./wrap_extention/Renderer/SoraCame";
import "./wrap_extention/Renderer/Image";
import "./wrap_extention/WRAP.Geo";
import "./wrap_extention/WRAP.Geo/Context/Canvas";
import "./wrap_extention/WRAP.Geo/Context/WebGL";
import "./wrap_extention/WRAP.Geo/Screen";
import "./wrap_extention/WRAP.Geo/View";
import "./wrap_extention/WRAP.Geo/Renderer/FIRExt";
import "./wrap_extention/WRAP.Geo/Renderer/ASCScaleExt";
import "./wrap_extention/WRAP.Geo/Bridge/GoogleMaps";
import "./wrap_extention/Loader";
import "./wrap_extention/Data/Controller/EXPO_NumericalDBExt";
import "./wrap_extention/Data/Controller/EXPO_NumericalDBExtCS";
import "./wrap_extention/Data/Controller/EXPO_RandomPointExt";
import "./wrap_extention/Data/Controller/EXPO_ObservationDBExt";
import "./wrap_extention/Data/Controller/IndexedJSON";
import "./wrap_extention/Data/Controller/LiveCameraExt";
import "./wrap_extention/Data/Controller/EXPO_TileExt";
import "./wrap_extention/Data/Controller/SoraCame";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { timeZoneSelector } from "../store/TimeZoneState";
const moment = require('moment-timezone');

export const WRAPInitializer = () => {
  const timeZone = useRecoilValue(timeZoneSelector);
  const {i18n} = useTranslation();
  WRAP.DH.conf_path = "pri/conf/data";
  WRAP.DH.set(WrapOption());
  WRAP.Configuration.cache.size = 1024 * 1024 * 1024;

  //UTCのタイムゾーンのフォーマットをUTC→Zに変更
  moment.tz.zone('utc').abbrs[0] = "Z";

  useEffect(() => {
    WRAP.Core.locale = i18n.language;
    WRAP.Geo.invalidate();
  }, [i18n.language]);

  useEffect(() => {
    WRAP.Core.setTimezone(timeZone);
    WRAP.Geo.invalidate();
  }, [timeZone]);

  WRAP.Data.customizeHttpRequest(function(xhr, url) {
    switch(true) {
      case (url.indexOf(`${process.env.REACT_APP_METARTAF_AVIATION_WEATHER_API_URL}/metar-taf/aviation_weather`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_METARTAF_AVIATION_WEATHER_API_KEY);
        break;
      case (url.indexOf(`${process.env.REACT_APP_FLIGHTPLAN_API_URL}/flightplan/`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_FLIGHTPLAN_API_KEY);
        break;
      case (url.indexOf(`${process.env.REACT_APP_ARINC_DATA_AUTH_API_URL}/auth/`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_ARINC_DATA_AUTH_API_KEY);
        break;
      case (url.indexOf(`${process.env.REACT_APP_CAMERA_API_URL}/owner/`) >= 0):
      case (url.indexOf(`${process.env.REACT_APP_CAMERA_API_URL}/camera/`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_CAMERA_API_KEY);
        if (url.indexOf('jpeg') >= 0) {
          //AWS経由のLivecamera画像取得には以下のヘッダが必要
          xhr.setRequestHeader('accept', 'image/*');
        }
        break;
      case (url.indexOf(`${process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_URL}/fosterlinks/`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_KEY);
        xhr.withCredentials = true;
        break;
      case (url.indexOf(`${process.env.REACT_APP_POSITION_API_URL}/aircraft/`) >= 0):
        xhr.setRequestHeader('x-api-key', process.env.REACT_APP_POSITION_API_KEY);
        break;
      default:
        break;
    }
  });

  //dont draw anything
  return null;
}

